<template>
    <v-container>
        <div class="graph-loader-container">
            <p v-show="loading" class="text-center">Generating graph, please wait...</p>
        </div>
        <div class="chart-container">
            <canvas v-show="!loading" :id="chartId" ref="barChart"></canvas>
        </div>
    </v-container>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
    name: 'BarChart',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        chartId: {
            type: String,
            default: 'bar-chart-id'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => {
            }
        },
        plugins: {
            type: Array,
            default: () => []
        },
        chartData: {
            type: Object,
            default: () => {
                return {
                    labels: [
                        'January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ],
                    datasets: [
                        {
                            label: 'Label',
                            backgroundColor: '#f87979',
                            data: [100, 300, 200, 400, 600, 700, 700, 500, 900, 1600, 1100, 1200]
                        }
                    ]
                }
            }
        },
        chartOptions: {
            type: Object,
            default: () => {
                return {
                    responsive: true,
                    maintainAspectRatio: false
                };
            }
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        // Watch for the chart data changes
        chartData(newChartData) {
            // Replace the chart data and call the update() method on Chart.js instance to re-render the chart
            if (this.chart) {
                this.chart.data = newChartData;
                this.chart.update();
            }
        }
    },
    mounted() {
        // Initialize the chart after the completion of the DOM update
        this.$nextTick(() => {
            setTimeout(() => {
                this.chart = new Chart(this.$refs.barChart, {
                    type: 'bar',
                    data: this.chartData,
                    options: this.chartOptions
                });
            }, 500);
        });
    },
    beforeDestroy() {
        // Don't forget to destroy the Chart.js instance
        if (this.chart) {
            this.chart.destroy()
        }
    }
}
</script>

<style>
.chart-container {
    width: 100%;
    height: 100%;
}

.chart-container canvas {
    width: 100% !important;
    height: 100% !important;
}

.graph-loader-container {
    width: 100% !important;
    height: 100% !important;
}
</style>
